import {Layout, ThemeColorName} from '@di-nxt/components';
import React, {useMemo} from 'react';
import {createBorder} from './functions';
import {BorderInfo} from './types';

type Props = {
  isHeader?: boolean;
  width?: number;
  height?: number;
  colIndex: number;
  rowIndex: number;
  colCount: number;
  rowCount: number;
  border?: BorderInfo;
  borderColor?: ThemeColorName;
  separatorColor?: ThemeColorName;
};

export const Cell: React.FC<Props> = ({
  isHeader,
  width,
  height,
  border,
  colCount,
  colIndex,
  rowCount,
  rowIndex,
  borderColor = 'border_mono_10',
  separatorColor = 'border_mono_30',
  children,
}) => {
  // Memoize borders
  const RightBorder = useMemo(() => createBorder('Right', borderColor), [
    borderColor,
  ]);
  const RightSeparator = useMemo(() => createBorder('Right', separatorColor), [
    separatorColor,
  ]);
  const BottomBorder = useMemo(() => createBorder('Bottom', borderColor), [
    borderColor,
  ]);
  const BottomSeparator = useMemo(
    () => createBorder('Bottom', separatorColor),
    [separatorColor],
  );

  // Create border props
  const borderProps = useMemo(
    () => ({
      // Right border
      ...((border === undefined || border !== 'none') &&
      !isHeader &&
      colCount - 1 !== colIndex
        ? border === 'vertical-separator' || border === 'separator'
          ? RightSeparator
          : RightBorder
        : {}),
      // Bottom border
      ...((border === undefined || border !== 'none' || isHeader) &&
      rowCount - 1 !== rowIndex
        ? border === 'horizontal-separator' || border === 'separator'
          ? BottomSeparator
          : BottomBorder
        : {}),
    }),
    [
      BottomBorder,
      BottomSeparator,
      RightBorder,
      RightSeparator,
      border,
      colCount,
      colIndex,
      isHeader,
      rowCount,
      rowIndex,
    ],
  );

  return (
    <Layout
      flex={width === undefined ? 1 : undefined}
      width={width}
      height={height}
      minWidth={width}
      maxWidth={width}
      borderPosition="inside"
      {...borderProps}>
      {children}
    </Layout>
  );
};
